export default "__VITE_ASSET__5389bb7c__"